import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import VueClipboard from 'vue-clipboard2';
  
import i18n from '@/libs/i18n'
import router from './router'
import store from './store'
import VueKanban from "vue-kanban";
import VueSignaturePad from 'vue-signature-pad';
import App from './App.vue'
import IdleVue from "idle-vue";
// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'

// Axios Mock Adapter
import '@/@fake-db/db'

import './registerServiceWorker'
import Swal from "sweetalert2";

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(VueKanban);
Vue.use(VueSignaturePad);
Vue.use(VueCompositionAPI)
Vue.use(VueClipboard);


const eventsHub = new Vue();

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 1202000, // 3 seconds
  startAtIdle: false
});

require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')


Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')

checkAppVersion();

router.beforeEach((to, from, next) => {
  checkAppVersion(); 
  next(); 
});


export function checkAppVersion() {
  const localVersion = localStorage.getItem("app_version");

  fetch(`/version.json?timestamp=${new Date().getTime()}`)
  .then(response => {
    if (!response.ok) throw new Error("Failed to load version.json");
    return response.json();
  })
    .then((data) => {
      const serverVersion = data.version;
      console.log("Fetched version from server:", serverVersion);

      console.log("serverVersion:", serverVersion);
      console.log("localVersion:", localVersion);
      if (!localVersion) {
        console.log("No local version found. Setting version:", serverVersion);
        localStorage.setItem("app_version", serverVersion);
      } else if (localVersion !== serverVersion) {
        
        console.log("Version mismatch detected. Clearing storage...");
        clearAllStorage(() => {
         
          showUpdateAlert();
        });
        
      } else {
        console.log("Version is up-to-date.");
      }
    })
    .catch((err) => {
      console.error("Error fetching version.json:", err);
    });
}

// -----------------------------
// Clearing Methods
// -----------------------------

export function clearAllStorage(callback) {
  localStorage.clear();
  sessionStorage.clear();
  clearCookies();
  clearCache();
  clearIndexedDB().then(() => {
    if (callback) callback();
  });
}


export function clearCookies() {
  document.cookie.split(";").forEach((cookie) => {
    document.cookie =
      cookie.trim().replace(/^([^=]+)=/, "$1=;expires=" + new Date(0).toUTCString() + ";path=/");
  });
}

export function clearCache() {
  if ("caches" in window) {
    caches.keys().then((cacheNames) => {
      cacheNames.forEach((cacheName) => caches.delete(cacheName));
    });
  }
}

export function clearIndexedDB() {
  return new Promise((resolve, reject) => {
    if ("indexedDB" in window) {
      const request = indexedDB.deleteDatabase("yourIndexedDBName");
      request.onerror = (event) => {
        console.error("Error deleting IndexedDB:", event);
        reject(event);
      };
      request.onsuccess = () => {
        console.log("IndexedDB deleted successfully");
        resolve();
      };
    } else {
      resolve();
    }
  });
}


export function refreshApp() {
  console.log("Clearing storage and refreshing...");
  location.reload();
}

export function showUpdateAlert(version) {
  Swal.fire({
    title: "Update Available",
    text: "A new version is available. Click on Refresh to update.",
    icon: "info",
    showConfirmButton: true,
    confirmButtonText: "Refresh",
    allowOutsideClick: false,
    allowEscapeKey: false,
  }).then((result) => {
    if (result.isConfirmed) {  
      // Start the timer after user clicks "Refresh"
      const timerDuration = 1000; // Timer duration in milliseconds (5 seconds for this example)
      Swal.fire({
        title: "Refreshing...",
        text: "The app will refresh in a few seconds.",
        icon: "info",
        allowOutsideClick: false,
        allowEscapeKey: false,
        timer: timerDuration,
        timerProgressBar: true,
        showConfirmButton: false,
      }).then(() => {
        // When the timer finishes, refresh the app
        refreshApp();
      });
    }
  });
}
